import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Pagination } from '@material-ui/lab';
import {
  Box, IconButton, Tooltip
} from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import useStyles from './styles';

export default function TableData(props) {
  const classes = useStyles();

  const columns = [
    ...props.columns,
  ];

  if (!props.hideOptions) {
    columns.push({
      name: 'acoes',
      label: 'Opções',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <>
            {props.showDetails && (
              <Tooltip title="Detalhes" aria-label="detalhes">
                <IconButton
                  color="warning"
                  aria-label="detalhes"
                  onClick={() => {
                    if (props.onDetails) {
                      props.onDetails(tableMeta.rowIndex);
                    }
                  }}
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            )}
            {props.showEdit && (
              <Tooltip title="Editar" aria-label="edit">
                <IconButton
                  color="primary"
                  aria-label="edit"
                  onClick={() => {
                    if (props.onEdit) {
                      props.onEdit(tableMeta.rowIndex);
                    }
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )}
            {props.showDelete && (
              <Tooltip title="Excluir" aria-label="delete">
                <IconButton
                  color="warning"
                  aria-label="delete"
                  onClick={() => {
                    if (props.onDelete) {
                      props.onDelete(tableMeta.rowIndex);
                    }
                  }}
                >
                  <DeleteForeverIcon />
                </IconButton>
              </Tooltip>
            )}
            {props.showRetry && (
              <Tooltip title="Enviar processo" aria-label="delete">
                <IconButton
                  color="warning"
                  aria-label="delete"
                  onClick={() => {
                    if (props.onRetry) {
                      props.onRetry(tableMeta.rowIndex);
                    }
                  }}
                >
                  <ReplayIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        )
        ,
      }
    });
  }

  return (
    <MUIDataTable
      title={props.title}
      data={props.data}
      columns={columns}
      options={{
        filter: false,
        sort: false,
        download: false,
        print: false,
        viewColumns: false,
        pagination: false,
        search: props.showSearch || false,
        selectableRows: 'none',
        searchPlaceholder: 'Buscar',
        customSearch: (query) => {
          if (props.search) {
            props.search(query);
          }
          return true;
        },
        onSearchClose: () => {
          if (props.onCloseSearch) {
            props.onCloseSearch('');
          }
        },
        customFooter: () => (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            className={classes.paginationContainer}
          >
            <Pagination
              count={props.total || 1}
              page={props.page || 1}
              onChange={(_, page) => {
                if (props.onSetPage) {
                  props.onSetPage(page);
                }
              }}
            />
          </Box>
        ),
        textLabels: {
          toolbar: {
            search: 'Buscar',
          },
          body: {
            noMatch: 'Sem resultados',
          }
        },
      }}
    />
  );
}
